module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedMedium.78d5836.woff2";